import {
  ACTIVATE_LOAN,
  ACTIVATE_LOAN_SUCCESS,
  ADD_BULK_LOAN,
  ADD_BULK_LOAN_BENEFICIARY,
  ADD_BULK_LOAN_BENEFICIARY_SUCCESS,
  ADD_BULK_LOAN_SUCCESS,
  ADD_CM_TO_LOAN,
  ADD_CM_TO_LOAN_SUCCESS,
  ADD_LOAN,
  ADD_LOAN_FAILURE,
  ADD_LOAN_SUCCESS,
  DEACTIVATE_LOAN,
  DEACTIVATE_LOAN_SUCCESS,
  DOWNLOAD_LOAN_BENEFICIARY_BULK_TEMPLATE,
  DOWNLOAD_LOAN_BENEFICIARY_BULK_TEMPLATE_SUCCESS,
  DOWNLOAD_LOAN_BULK_TEMPLATE,
  DOWNLOAD_LOAN_BULK_TEMPLATE_SUCCESS,
  EMPTY_ALL_LOANS,
  EMPTY_ALL_LOAN_BENEFICIARIES_TO_LOAN,
  EMPTY_ALL_TOTAL_LOAN_BENEFICIARY,
  EMPTY_LOAN_BY_ID,
  EMPTY_LOAN_SELECT,
  EMPTY_TOTAL_LOANS,
  EXPORT_LOANS,
  EXPORT_LOANS_SUCCESS,
  EXPORT_LOAN_BENEFICIARIES_BY_LOAN,
  EXPORT_LOAN_BENEFICIARIES_BY_LOAN_SUCCESS,
  FETCH_ALL_LOANS,
  FETCH_ALL_LOANS_FAILURE,
  FETCH_ALL_LOANS_SUCCESS,
  FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN,
  FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN_SUCCESS,
  FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS,
  FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS_SUCCESS,
  FETCH_ALL_TOTAL_LOAN_DETAILS,
  FETCH_ALL_TOTAL_LOAN_DETAILS_SUCCESS,
  FETCH_LOAN_BY_ID,
  FETCH_LOAN_BY_ID_SUCCESS,
  FETCH_LOAN_SELECT,
  FETCH_LOAN_SELECT_SUCCESS,
  RESTORE_LOAN_BENEFICIARIES_TO_LOAN_INITIAL,
  RESTORE_LOAN_INITIAL,
  UPDATE_LOAN,
  UPDATE_LOAN_SUCCESS,
} from "../ActionTypes";

export const addNewLoan = (payload) => ({
  type: ADD_LOAN,
  payload,
});

export const addNewLoanSuccess = (payload) => ({
  type: ADD_LOAN_SUCCESS,
  payload,
});

export const addNewLoanFailure = (payload) => ({
  type: ADD_LOAN_FAILURE,
  payload,
});

// to get all loans

export const fetchLoans = (payload) => ({
  type: FETCH_ALL_LOANS,
  payload,
});

export const fetchLoansSuccess = (payload) => ({
  type: FETCH_ALL_LOANS_SUCCESS,
  payload,
});

export const fetchLoansFailure = (payload) => ({
  type: FETCH_ALL_LOANS_FAILURE,
  payload,
});

export const emptyLoans = () => ({
  type: EMPTY_ALL_LOANS,
});

export const restoreLoanInitial = () => ({
  type: RESTORE_LOAN_INITIAL,
});

// To Activate and Deactivate loan
export const activateLoan = (id) => ({
  type: ACTIVATE_LOAN,
  payload: id,
});

export const activateLoanSuccess = (payload) => ({
  type: ACTIVATE_LOAN_SUCCESS,
  payload,
});

export const deactivateLoan = (id) => ({
  type: DEACTIVATE_LOAN,
  payload: id,
});

export const deactivateLoanSuccess = (payload) => ({
  type: DEACTIVATE_LOAN_SUCCESS,
  payload,
});

// To fetch loan by id
export const fetchLoanById = (id) => ({
  type: FETCH_LOAN_BY_ID,
  payload: id,
});

export const fetchLoanByIdSuccess = (payload) => ({
  type: FETCH_LOAN_BY_ID_SUCCESS,
  payload,
});

export const emptyLoanById = () => ({
  type: EMPTY_LOAN_BY_ID,
});

// To update loan
export const updateLoan = (payload) => ({
  type: UPDATE_LOAN,
  payload,
});
export const updateLoanSuccess = (payload) => ({
  type: UPDATE_LOAN_SUCCESS,
  payload,
});

// To fetch all total loan details
export const fetchAllTotalLoanDetails = () => ({
  type: FETCH_ALL_TOTAL_LOAN_DETAILS,
});
export const fetchAllTotalLoanDetailsSuccess = (payload) => ({
  type: FETCH_ALL_TOTAL_LOAN_DETAILS_SUCCESS,
  payload,
});

export const emptyTotalLoans = () => ({
  type: EMPTY_TOTAL_LOANS,
});

// To export loans
export const exportLoans = () =>({
  type: EXPORT_LOANS,
})
export const exportLoansSuccess = (payload) =>({
  type: EXPORT_LOANS_SUCCESS,
  payload
})

// To fetch all loans without pagination
export const fetchLoanSelect = () => ({
  type: FETCH_LOAN_SELECT
});

export const fetchLoanSelectSuccess = (payload) => ({
  type: FETCH_LOAN_SELECT_SUCCESS,
  payload
});

export const emptyLoanSelect = () =>({
  type: EMPTY_LOAN_SELECT
});

// To fetch all total loan beneficiary details
export const fetchAllTotalLoanBeneficiaryDetails = () =>({
  type: FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS,
})

export const fetchAllTotalLoanBeneficiaryDetailsSuccess = (payload) =>({
  type: FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS_SUCCESS,
  payload
})

export const emptyAllTotalLoanBeneficiary = () =>({
  type: EMPTY_ALL_TOTAL_LOAN_BENEFICIARY,
})

//To add CM to Loan

export const addCMToLoan = (payload) => ({
  type: ADD_CM_TO_LOAN,
  payload,
});

export const addCMToLoanSuccess = (payload) => ({
  type: ADD_CM_TO_LOAN_SUCCESS,
  payload,
});

// to get all loan beneficiaries to loan

export const fetchLBToLoan = (id) => ({
  type: FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN,
  payload: id,
});

export const fetchLBToLoanSuccess = (payload) => ({
  type: FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN_SUCCESS,
  payload,
});

export const emptyLBToLoan = () => ({
  type: EMPTY_ALL_LOAN_BENEFICIARIES_TO_LOAN,
});

export const restoreLBToLoanInitial = () => ({
  type: RESTORE_LOAN_BENEFICIARIES_TO_LOAN_INITIAL,
});

// To export loan beneficiaries by loan
export const exportLBbyLoan = (id) =>({
  type: EXPORT_LOAN_BENEFICIARIES_BY_LOAN,
  payload: id
})
export const exportLBbyLoanSuccess = (payload) =>({
  type: EXPORT_LOAN_BENEFICIARIES_BY_LOAN_SUCCESS,
  payload
})

// To download loan bulk template
export const downloadBulkLoan = () =>({
  type: DOWNLOAD_LOAN_BULK_TEMPLATE,
})
export const downloadBulkLoanSuccess = (payload) =>({
  type: DOWNLOAD_LOAN_BULK_TEMPLATE_SUCCESS,
  payload
})

// To add bulk loan
export const addBulkLoan = () =>({
  type: ADD_BULK_LOAN,
})
export const addBulkLoanSuccess = (payload) =>({
  type: ADD_BULK_LOAN_SUCCESS,
  payload
})

// To download loan beneficiary bulk template
export const downloadBulkLB = () =>({
  type: DOWNLOAD_LOAN_BENEFICIARY_BULK_TEMPLATE,
})
export const downloadBulkLBSuccess = (payload) =>({
  type: DOWNLOAD_LOAN_BENEFICIARY_BULK_TEMPLATE_SUCCESS,
  payload
})

// To add bulk loan beneficiary
export const addBulkLB = () =>({
  type: ADD_BULK_LOAN_BENEFICIARY,
})
export const addBulkLBSuccess = (payload) =>({
  type: ADD_BULK_LOAN_BENEFICIARY_SUCCESS,
  payload
})
